export default __webpack_public_path__ + "static/media/giftbox.1776d43f.png";